define([
	"jquery",
	"domReady",
	"wcs.mini-list",
	"wcs.context",
	'shared.main.screen',
	"promise!wcs.lang-msg",
	"pubsub",
	"foundation.util.keyboard"
], function ($, domReady, miniList, ctx, screenSize) {

	var cartContentsURL = (window.ACTION_URLS && window.ACTION_URLS.MINI_SHOPPING_URL) ? window.ACTION_URLS.MINI_SHOPPING_URL : '';
	var DEBUG = Boolean(window.localStorage.getItem('DEBUG')) || false;
	var topPanel = function () {
		var self = this;
		// Set variables
		this.disableMiniCart = ($('body').data('disableMiniCart')) ? $('body').data('disableMiniCart') : false;
		this.$topMiniCart = $('.topnav-minicart-panel, .global-cart-wishlist-panels-top-js');
		this.$toggle = $('.topnav-cart, .unav-shoppingbag-js');
		this.$topNavCart = $('.topnav-utility .topnav-cart a');
		this.$cartLink = this.$toggle.find('a');
		this.isOpen = false;
		this.autoHide = false;
		this.insideMiniCart = false;
		// When minicart is automatically opened, or when user mouses out
		// of the minicart, this controls how long to wait before
		// automatically dismissing the minicart. It is usually a long
		// value like 5-6 seconds.
		this.autoHideTimeOut = parseInt(WCS_CONFIG.get('global::miniCartAutoHideTime'));
		// When users accidentally mouse over the cart link, they shouldn't
		// have to wait the full 5-6 seconds for the minicart to close since
		// that can prevent them from getting to the search box or other
		// features. This value is kept short to give just enough time for
		// the user transition from the link to the minicart panel and keep
		// it from closing while moving the mouse (like a dropdown menu)
		this.mouseOutTime = 250;
		this.cartMinHeight = parseInt(WCS_CONFIG.get('global::miniCartMinHeight'));
		this.timerQueue = [];
		this.wasOpened = false; // Tracks if the minicart was ever opened
		this.cartContentsURL = cartContentsURL;
		this.repositionMiniCartWhenOpening = WCS_CONFIG.get('global::repositionMiniCartWhenOpening');
		/**
		 * Clear all timer IDs stored in the queue
		 * @private
		 **/
		this._clearAllTimers = function () {
			self.timerQueue.forEach(function (timer) {
				clearTimeout(timer);
			});
		};

		/**
		 * Add a new timer to the queue, but don't flush others
		 * @param number ID for a javascript timer as generated from setTimeout()
		 **/
		this._addTimer = function (timer) {
			self.timerQueue.push(timer);
		};

		/**
		 * Insert a new timer in the queue replacing all others
		 * @param number ID for a javascript timer as generated from setTimeout()
		 **/
		this._replaceTimers = function (timer) {
			self._clearAllTimers();
			self._addTimer(timer);
		};

		/**
		 * Immediately close the minicart without delay
		 **/
		this.closeMiniCart = function () {
			// Kill any timer
			self._clearAllTimers();
			// Close the minicart
			return self._hideTopMiniCart();
		};

		/**
		* Check to see if Sticky Nav is enabled
		**/
		this.isStickyNavEnabled = function () {

			if ($('header.sticky-minimized').length > 0) {
				// CMS sticky nav is enabled
				return true;
			}

			var $ecomHeader = $('.header-container');

			if ($ecomHeader.has('.fixed-medium').length > 0 && screenSize.size() !== "small") {
				// ECOM sticky nav is enabled for medium screen and up, and user is using medium screen or larger
				return true;
			}

			if ($ecomHeader.has('.fixed-small').length > 0 && screenSize.size() === "small") {
				// ECOM sticky nav is enabled for small screen, and user is using small screen
				return true;
			}

			// Sticky Nav not in-use
			return false;
		};

		/**
		 * Immediately open the minicart
		 * @param {Object} [options]
			 *   the options for opening the minicart
		 *	 {
		 *     autoHide: false, // Whether to autohide
		 *     autoHideTimeOut: XXXX // How long to wait before autohide
		 *     openOnHover: false // Indicate whether minicart was opened by hover event (for analytics purposes)
		 *   }
		 **/
		this.openMiniCart = function (options) {
			if(DEBUG) console.log('top-panels.js', 'openMiniCart', options);
			options = options || {};
			// Allow for 0 timer or false to disable
			var autoHideTimeOut = options.autoHideTimeOut || self.autoHideTimeOut;
			var isInit = !self.wasOpened;

			// Track the first open
			self.wasOpened = true;

			// Reset any running autohide timer
			self._clearAllTimers();

			return self._showTopMiniCart().then(function() {
				return self.populateTopMiniCart(isInit).then(function() {

					// Setup timer
					if(options.autoHide) {
						self._replaceTimers(setTimeout(function () {
							self.closeMiniCart();
						}, autoHideTimeOut));
					}

					// Scroll the page so minicart is in view only if Sticky Nav is not enabled
					if (!self.isStickyNavEnabled() && !self.disableMiniCart ) {
						$(window).scrollTop(0);
					}

					// when user initiates opening minicart, push event to datalayer for analytics tracking
					if (options.openOnHover) {
						try {
							window.dataLayer.push({
								'event': 'miniCartView',
								'location': 'top-panel'
							});
						} catch (err) {
							console.error('Failed push to dataLayer', err);
						}
					}
				});
			});
		};

		this.getTopMiniCartType = function () {
			var miniCartType = ($('.topnav-cart').length > 0 ? 'cms' : 'ecom');
			return miniCartType;
		};

		this.positionTopMiniCart = function () {
			var top;
			var right = 0;

			if(screenSize.size() === 'small' || !this.repositionMiniCartWhenOpening) {
				// reset inline css and default to brand CSS styles
				self.$topMiniCart.css({
					right: '',
					top: '',
					minHeight: ''
				});
				return;
			}
			if (this.$topNavCart.length > 0) {
				var pos = this.$topNavCart[0].getBoundingClientRect();
				top = pos.height + pos.top;
			}

			if (self.getTopMiniCartType() === 'ecom') {
				right = 10 + ($(window).width() - $('.master-header').innerWidth()) / 2;
			}

			self.$topMiniCart.css({
				right: right,
				top: top,
				minHeight: self.cartMinHeight
			});
		};

		this.populateTopMiniCart = function (isInit, msg, SHOPCART_UPDATED) {
			if(DEBUG) console.log('top-panels.js', 'populateTopMiniCart');
			isInit = isInit || false;
			var $container = self.$topMiniCart,
				data = {
					'storeId': ctx.getStoreId(),
					'langId': ctx.getLangId(),
					'catalogId': ctx.getCatalogId()
				},
				settings = {
					'title': LANG_MSG["DEAFULT_MINICART.SHOPPING.title"],
					'page': 'shopcart',
					'container': $container.find('.shopcart.cart-list'),
					'isInit': isInit,
					'globalLoading': msg ? msg.globalLoading : true
				};

			if ($('.cart-item-slide-js').find('.cart-item-js').length === 0 || SHOPCART_UPDATED === 'SHOPCART_UPDATED') {
				return miniList.renderMiniListItems(self.cartContentsURL, data, settings, msg);
			} else {
				miniList.initCarousel(settings);
				return $.Deferred().resolve().promise();
			}
		};

		this._showTopMiniCart = function () {
			if(DEBUG) console.log('top-panels.js', '_showTopMiniCart');
			var deferred = new $.Deferred();
			self.isOpen = true;

			// reposition when opening
			self.positionTopMiniCart();
			self.$toggle.addClass('active active-js');
			self.$topMiniCart.removeClass('hide').addClass('fade-in');

			// Trigger Add to Cart message for Screen Readers on Desktop
			if(screenSize.size() !== 'small') {
				var $notification = self.$topMiniCart.find('.notification');
					$('.minicart-sr-text-js').insertBefore($notification);
			}

			setTimeout(function () {
				self.$topMiniCart.removeClass('fade-in').find('.cart-js').addClass('active-js');
				deferred.resolve();
			}, self.mouseOutTime);

			return deferred.promise();
		};

		this._hideTopMiniCart = function () {
			if(DEBUG) console.log('top-panels.js', '_hideTopMiniCart');
			var deferred = new $.Deferred();
			self.isOpen = false;

			self.$toggle.removeClass('active active-js').siblings().removeClass('inactive inactive-js');
			self.$topMiniCart.addClass('fade-out').find('.cart-js').removeClass('active-js');

			setTimeout(function () {
				self.$topMiniCart.addClass('hide').removeClass('fade-out').find('.notification').addClass('hide');
				if(screenSize.size() !== 'small') {
					$('.minicart-sr-text-js').remove();
				}
				deferred.resolve();
			}, self.mouseOutTime);

			return deferred.promise();
		};

		this.shopcartUpdateAction = function (msg, data) {
			if(DEBUG) console.log('top-panels.js', 'shopcartUpdateAction', msg, data);

			var autoHide = (data.action === 'delete') ? false : true;

			// Only do this with medium and up screens
			if (screenSize.size() !== "small" && data) {
				// trigger the minicart contents to be loaded
				self.populateTopMiniCart(false, data, 'SHOPCART_UPDATED').done(function() {
					return self.openMiniCart({
						autoHide: autoHide
					});
				}).done(function() {
					// If the user is inside the minicart by way of the keyboard
					// select the first focusable element in the list
					// and trap the keyboard.
					if(self.insideMiniCart) {
						var focusable = Foundation.Keyboard.findFocusable(self.$topMiniCart);
						if(focusable) {
							focusable.first().focus();
							Foundation.Keyboard.trapFocus(self.$topMiniCart);
						}
					}
				});
			} else {
				self.openMiniCart();
			}
		};

		/**
		 * Handler for the mouseover event on the utility nav minicart
		 *
		 * Opens the minicart only if it has products and only on
		 * larger screen sizes
		 **/
		this._utilityNavMouseOverHandler = function () {
			if(DEBUG) console.log('top-panels.js', '_utilityNavMouseOverHandler');
			// Don't open if it isn't registered as having products
			if (!self.$toggle.hasClass('has-products')) {
				return false;
			}

			// Don't open on smaller screens
			if ($.inArray(screenSize.size(), ['small', 'medium']) >= 0) {
				return false;
			} else {
				$.pubsub('publish', 'vfdp.toppanel.OPEN_MINI_CART');
			}

			self.openMiniCart({
				autoHide: true,
				openOnHover: true // indicate minicart is opened on mouseover event for analytics
			});
		};

		/**
		 * Setup event listerns for interactions within mini cart
		 *
		 * @param {Object} [el] JQuery object containing the minicart
		 **/
		this._minicartInteractionEvents = function (el) {
			if(DEBUG) console.log('top-panels.js', '_minicartInteractionEvents');
			el.on({
				// Stop autohide timer if user interacts with open minicart using touch screen
				touchstart: function (event) {
					if(DEBUG) console.log('top-panels.js', '_utilityNavMouseOverHandler', 'touchstart');
					if (self.isOpen) {
						self._clearAllTimers();
					}
				},
				// Stop autohide timer if user mouses into the minicart
				mouseenter: function (event) {
					if(DEBUG) console.log('top-panels.js', '_utilityNavMouseOverHandler', 'mouseenter');
					self._clearAllTimers();
				},
				// Start autohide timer if user mouses off the minicart
				mouseleave: function (event) {
					if(DEBUG) console.log('top-panels.js', '_utilityNavMouseOverHandler', 'mouseleave');
					if (self.isOpen) {
						self._replaceTimers(setTimeout(function () {
							self.closeMiniCart();
						}, self.autoHideTimeOut));
					}
				}
			});
		};

		/**
		 * Setup event listeners for the minicart link
		 *
		 * @param {Object} [el] JQuery object containing the minicart link
		 **/
		this._linkInteractionEvents = function (el) {
			if(DEBUG) console.log('top-panels.js', '_linkInteractionEvents');
			el.on({
				// Open minicart on mouseover
				mouseenter: function (ev) {
					if(DEBUG) console.log('top-panels.js', '_linkInteractionEvents', 'mouseenter');
					self._utilityNavMouseOverHandler();
				},
				// Close minicart on mouseout
				mouseleave: function (ev) {
					if(DEBUG) console.log('top-panels.js', '_linkInteractionEvents', 'mouseleave');
					// set a short timer before dismissing
					// to allow for mousing from link to minicart contents
					self._replaceTimers(setTimeout(function () {
						self.closeMiniCart();
					}, self.mouseOutTime));
				}
			});
		};

		this.cartLinkHasFocus = function() {
			return this.$cartLink.is(':focus');
		};

		/**
		 * Setup event listeners
		 */
		this.events = function () {
			// Stop the autohide timer if Email Cart feature is opened
			$.pubsub('subscribe', 'EMAIL_ME_MY_CART_ACTION', function () {
				self._clearAllTimers();
			});

			// Restart autohide timer when Email Cart feature is finished
			$.pubsub('subscribe', 'EMAIL_ME_MY_CART_FINISHED', function () {
				//Start Timer again when EMMC is finished/Closed/Not Active
				self._replaceTimers(setTimeout(self.closeMiniCart, self.autoHideTimeOut));
			});

			// Close the minicart if user taps or clicks on close icon
			$(self.$topMiniCart).on('click', '.mini-cart-icon-close-js', function (event) {
				self.closeMiniCart();
			});

			// Close the minicart if user taps or clicks outside
			$(document).on('click touchstart', function (event) {
				if ($(event.target).closest(self.$topMiniCart).length <= 0) {
					self.closeMiniCart();
				}
			});

			// Close the mini cart whenever a modal opens
			$(document).on('open.zf.reveal', function () {
				self.closeMiniCart();
			});

			// Open the mini cart when the free gift offer completes
			$.pubsub('subscribe', 'vfdp.wcs.free_gift.offer_complete', function () {
				self.openMiniCart({
					autoHide: true
				});
			});

			// Listen for SHOPCART_UPDATED events
			$.pubsub('subscribe', 'SHOPCART_UPDATED', self.shopcartUpdateAction.bind(self));

			// Mouse and touch events for keeping the minicart open
			// when user interacts with the minicart link in utility nav
			self._linkInteractionEvents(self.$toggle);

			// Mouse and touch events for keeping the minicart open
			// when user interacts with the cart
			self._minicartInteractionEvents(self.$topMiniCart);

			// Apply focus to first focusable element in minicart when render is complete
			$.pubsub('subscribe', 'MINICART_CONTENT_RENDER_COMPLETE', function(event, data) {
				var focusable =$('.topnav-minicart-panel').find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
				$(focusable).first().focus();
				self.insideMiniCart = true;
			});

			Foundation.Keyboard.register('miniCart', {
				'SPACE': 'enterMiniCart',
				'ESCAPE': 'exitMiniCart',
				'ENTER': 'followMiniCartLink',
				'TAB': 'navigatingMiniCart',
				'SHIFT_TAB': 'navigatingMiniCart'
			});

			$(document).on('keydown.top-panel.minicart', function(event) {
				Foundation.Keyboard.handleKey(event, 'miniCart', {
					enterMiniCart: function() {
						if(DEBUG) console.log('top-panels.js', 'keydown.top-panel.minicart', 'enterMiniCart');
						// Don't open and enter the minicart if we don't have products
						if(!self.cartLinkHasFocus() || !self.$toggle.hasClass('has-products'))
							return;
						event.preventDefault();
						$.pubsub('publish', 'vfdp.toppanel.OPEN_MINI_CART');
						self.openMiniCart({
							autoHide: false,
							openOnHover: true // indicate minicart is opened on mouseover event for analytics
						}).done(function() {
							if(!self.insideMiniCart) {
								self.insideMiniCart = true;
								var focusable = Foundation.Keyboard.findFocusable(self.$topMiniCart);
								if(focusable) {
									focusable.first().focus();
									Foundation.Keyboard.trapFocus(self.$topMiniCart);
								}
							}
						});
					},
					navigatingMiniCart: function() {
						if(DEBUG) console.log('top-panels.js', 'keydown.top-panel.minicart', 'navigatingMiniCart');
						//Reset timer while user is navigating mini cart
						self._replaceTimers(setTimeout(function () {
							self.closeMiniCart();
						}, self.autoHideTimeOut));
					},
					exitMiniCart: function() {
						if(DEBUG) console.log('top-panels.js', 'keydown.top-panel.minicart', 'exitMiniCart');
						// Bail out if we aren't inside the minicart
						if(!self.insideMiniCart)
							return;
						// Release the minicart focus trap
						Foundation.Keyboard.releaseFocus(self.$topMiniCart);
						// Move focus back to the cart link
						self.$cartLink.focus();
						// Close the minicart
						self.closeMiniCart();
						self.insideMiniCart = false;
					},
					followMiniCartLink: function() {
						if(DEBUG) console.log('top-panels.js', 'keydown.top-panel.minicart', 'followMiniCartLink');
						// Make sure we filter the enter key for focus on the cart link
						if(self.cartLinkHasFocus())
							self.$cartLink.trigger('click');
					}
				});
			});
		};

		this.init = function () {
			self.positionTopMiniCart();
			// Setup events everywhere but checkout
			if ($('body#checkout').length === 0) {
				self.events();
			}

			return this;
		};
	};

	return new topPanel().init();
});
